import React from 'react'
// react component for creating dynamic tables
import ReactTable from 'react-table'
import { withRouter } from 'react-router'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons
import Assignment from '@material-ui/icons/Assignment'
import DeleteForever from '@material-ui/icons/DeleteForever'
import ZoomIn from '@material-ui/icons/ZoomIn'

// core components
import Button from 'components/CustomButtons/Button.jsx'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx'
import { deleteRecord } from '../../services/generalServiceAPI'
import AppContext from '../../services/context'

import { toUpper, isEqual } from 'lodash'
import { jsonPP, titleCase, reactTableFilterCaseInsensitive } from '../utility/utility'

import { retrieveSomeRoutes } from '../../services/generalServiceAPI'
import swal from 'sweetalert2'

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
}

class containerTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      pageNumber: 0,
      pageSize: 20,
      filtered: [],
      sorted: [],
      loading: true,
    }
    this.loadData = this.loadData.bind(this)
  }
  static contextType = AppContext

  loadDataPieceByPiece = async (args) => {
    const { pageNumber, pageSize, filtered, sorted, partial } = {
      ...this.state,
      ...args,
    }
    // console.log({ pageNumber, pageSize, filtered, sorted })
    // removed pageSize from the following, it govers how many records returned from the query, was limited to 10 sinze it's using the
    // pageSize in this.state which should be set for pagination on the table.
    await retrieveSomeRoutes({ pageNumber, filtered, sorted, source: 'table' })
      .then(
        ({
          data: {
            someRoutes: { pages, routes },
          },
        }) => {
          if (partial && pageNumber > 1) {
            this.setState({
              restOfData: {
                pages,
                routes: this.state.restOfData ? [...this.state.restOfData.routes, ...routes] : routes,
              },
            })
          } else {
            this.setState({
              data: {
                pages,
                routes,
              },
              pageSize,
              pageNumber,
              filtered,
              sorted,
              loading: false,
            })
          }

          if (pageNumber < this.state.data.pages && partial) {
            this.loadData({ pageNumber: pageNumber + 1, pageSize, filtered, sorted, partial })
          } else {
            // console.log(this.state)
            this.setState({
              data: {
                pages,
                routes: [...this.state.data.routes, ...this.state.restOfData.routes],
              },
            })
          }
          // console.log(this.state.data.routes.length(), this.state.restOfData.routes.length())
        }
      )
      .catch((e) => {
        swal.fire({ title: 'Error in loadData of routing table', html: e.message, type: 'error' })
        this.setState({
          data: {
            pages: -1,
            routes: [],
          },
          loading: false,
        })
      })
  }
  loadData = async (args) => {
    const { pageNumber, pageSize, filtered, sorted } = {
      ...this.state,
      ...args,
    }
    this.setState({
      loading: true,
    })
    // console.log({ pageNumber, pageSize, filtered, sorted })
    await retrieveSomeRoutes({ pageSize, pageNumber, filtered, sorted, source: 'table' })
      .then(
        ({
          data: {
            someRoutes: { pages, routes },
          },
        }) => {
          // console.log({ pages, routes })
          this.setState({
            data: {
              pages,
              routes: routes ? routes : [],
            },
            loading: false,
          })
        }

        // console.log(this.state.data.routes.length(), this.state.restOfData.routes.length())
      )

      .catch((e) => {
        swal.fire({ title: 'Error in loadData of routing table', html: e.message, type: 'error' })
        this.setState({
          data: {
            pages: -1,
            routes: [],
          },
          loading: false,
        })
      })
  }
  componentDidMount() {
    const filter = localStorage.getItem('routeFilter')
    this.setState(JSON.parse(filter))
    const { pageNumber, pageSize, filtered, sorted } = this.state
    this.loadData({ pageNumber, pageSize, filtered, sorted, partial: true })
  }
  componentWillUnmount() {
    const { filtered } = this.state
    localStorage.setItem('routeFilter', JSON.stringify({ filtered }))
  }
  // This component gets data from props not state since there is no in-place editing allowed
  // The way to retrive data in the above method- didMount seems more neat than 'render function binding', but will keep using the binding way
  // since that's what they recommand and seems the error handling is more standard
  render() {
    const { classes, history } = this.props
    const {
      data: { pages, routes },
      pageNumber,
    } = this.state
    // console.log(this.props)
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color='primary' icon>
              <CardIcon color='primary'>
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Routes </h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={routes}
                filterable
                loading={this.state.loading}
                // LoadingComponent={Loader}
                filtered={this.state.filtered}
                overflow='hidden'
                defaultFilterMethod={(filter, row) => reactTableFilterCaseInsensitive(filter, row)}
                defaultSorted={[
                  {
                    id: 'name',
                    desc: true,
                  },
                ]}
                // pagination starts
                onFilteredChange={(filtered) => {
                  const filterChangedTimer = setTimeout(this.loadData, 1000)
                  clearTimeout(this.state.filterChangedTimer)
                  this.setState({ filtered, filterChangedTimer })
                }}
                onSortedChange={(sorted) => {
                  this.setState({ sorted })
                  this.loadData({ sorted })
                }}
                manual
                pages={pages}
                page={pageNumber}
                pageSize={20}
                onPageChange={(pageNumber) => {
                  this.setState({ pageNumber })
                  this.loadData({ pageNumber })
                }}
                onPageSizeChange={(pageSize) => {
                  this.setState({ pageSize })
                  this.loadData({ pageSize })
                }}
                // pagination ends
                columns={[
                  {
                    Header: 'Type',
                    id: 'expenseTypeId',
                    // do not populate expense type for application other than GAT
                    //accessor: route => `${route.typeOfApplication.short}[${route.expenseOrProcurement}]${route.expenseType ? '[' + route.expenseType.name + ']' : ''}`,
                    accessor: ({ typeOfApplicationId, typeOfApplication, expenseOrProcurement, expenseType }) => {
                      if (typeOfApplicationId === 0) {
                        return `${toUpper(expenseOrProcurement)} ${expenseType ? '[' + titleCase(expenseType.name) + ']' : ''}`
                      } else {
                        return `${toUpper(typeOfApplication.short)}`
                      }
                    },
                    width: 390,
                    filterable: true,
                  },
                  {
                    id: 'companyId',
                    Header: 'Company',
                    accessor: 'company.name',
                    width: 200,
                    filterable: true,
                  },
                  {
                    Header: 'Departments',
                    id: 'departments',
                    accessor: ({ departments }) => departments.map((d) => <div key={Math.random(6)}>{d.name}</div>),
                    width: 170,
                    filterable: false,
                    sortable: false,
                  },
                  {
                    Header: 'Path',
                    id: 'signingPathId',
                    accessor: 'signingPath.name',
                    // accessor: ({ signingPath }) => `${signingPath.name}(${signingPath.numberOfLevels})`,
                    // filterMethod: (filter, row) => {
                    //   console.log(filter)
                    // },
                    filterable: true,
                  },
                  {
                    Header: 'Level',
                    id: 'level',
                    //accessor: 'levelToFinish',
                    accessor: ({ unconditionallyRoute, signingPath, levelToFinish }) =>
                      unconditionallyRoute ? `n/a` : `${levelToFinish}/${signingPath.numberOfLevels}`,
                    width: 80,
                    filterable: false,
                    sortable: false,
                  },
                  {
                    Header: () => <div style={{ textAlign: 'left' }}>Actions</div>,
                    id: 'actions',
                    filterable: false,
                    sortable: false,
                    accessor: (d) => (
                      <div>
                        <Button
                          justIcon
                          round
                          simple
                          onClick={(e) => {
                            this.context.route = d
                            this.context.routes = routes.filter((r) => {
                              // One If for each type, so it won't affect each other when new one added
                              if (r.typeOfApplicationId > 0) {
                                return r.typeOfApplicationId === d.typeOfApplicationId && r.companyId === d.companyId && r.signingPathId === d.signingPathId
                                // } else if (r.typeOfApplicationId === 0) {
                              } else {
                                return (
                                  r.typeOfApplicationId === d.typeOfApplicationId &&
                                  r.companyId === d.companyId &&
                                  r.signingPathId === d.signingPathId &&
                                  r.expenseOrProcurement === d.expenseOrProcurement &&
                                  r.expenseTypeId === d.expenseTypeId &&
                                  isEqual(r.departments, d.departments)
                                )
                              }
                            })
                            history.push('/systemadmin/update-route')
                          }}
                          color='primary'
                        >
                          <ZoomIn className={classes.icon} />
                        </Button>
                        <Button
                          justIcon
                          round
                          simple
                          onClick={async (e) => {
                            await deleteRecord({ id: d.id, tableName: 'routes', refetch: this.props.refetch })
                          }}
                          color='primary'
                        >
                          <DeleteForever className={classes.icon} />
                        </Button>
                      </div>
                    ),
                  },
                  // don't need this tweak
                  // {
                  //   //fix alignment bug
                  //   width: -1,
                  //   filterable: false
                  // }
                ]}
                // getTrProps={(state, rowInfo) => {
                //   return {
                //     onClick: e => {
                //       // console.log(state, rowInfo)
                //       // this.context.signingPath = rowInfo.original
                //       // history.push('/systemadmin/update-signingpath')
                //     }
                //   }
                // }}
                // defaultPageSize={this.state.pageSize}
                defaultPageSize={10}
                //minRow={3}
                //headClassname=""
                showPaginationTop={false}
                showPaginationBottom={true} //={true} //can be ignored
                className='-striped -highlight'
              />
            </CardBody>
          </Card>
        </GridItem>
        {/* {jsonPP(this.state.data)} */}
        {jsonPP(this.state.filtered)}
        {jsonPP(this.state.filterChangedTimer)}
      </GridContainer>
    )
  }
}

export default withRouter(withStyles(styles)(containerTable))
